/** @jsx jsx */
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';
import { Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import ReactCountdown from 'react-countdown';
// https://github.com/ndresx/react-countdown

import { ICustomTheme } from 'interfaces';

const StyledTime = styled(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ disabled, highlighted, ...props }) => (
    <Typography variant="h4" {...props} />
  ),
  // voluntarily exclude 'disabled' prop to not give it to Mui component
)<{ theme: ICustomTheme; disabled: boolean; highlighted: boolean }>(
  ({ theme, disabled, highlighted }) => {
    let backgroundColor = theme.colors.paletteFromBO.primary;
    if (highlighted) {
      backgroundColor = theme.colors.paletteFromBO.secondary;
    }
    if (disabled) {
      // eslint-disable-next-line prefer-destructuring
      backgroundColor = theme.colors.paletteFromBO.tertiary;
    }
    return {
      backgroundColor,
      borderRadius: theme.shape.borderRadius,
      color: theme.colors.white,
      fontWeight: theme.typography.fontWeightMedium,
      height: 42,
      lineHeight: '39px',
      minWidth: 45,
      textAlign: 'center',
    };
  },
);

const Small = styled.span({
  fontSize: '55%',
});

const CountDown = ({
  before,
  centered,
  disabled,
  highlighted,
}: {
  before: Date;
  centered: boolean;
  disabled: boolean;
  highlighted: boolean;
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <ReactCountdown
      date={before}
      renderer={({ days, hours, minutes, seconds }) => (
        <Grid
          container
          spacing={1}
          justify={centered ? 'center' : 'flex-start'}
        >
          <Grid item>
            <StyledTime disabled={disabled} highlighted={highlighted}>
              {days}
              <Small>{t('time.days_abbreviation')}</Small>
            </StyledTime>
          </Grid>
          <Grid item>
            <StyledTime disabled={disabled} highlighted={highlighted}>
              {hours}
              <Small>{t('time.hours_abbreviation')}</Small>
            </StyledTime>
          </Grid>
          <Grid item>
            <StyledTime disabled={disabled} highlighted={highlighted}>
              {minutes}
              <Small>{t('time.minutes_abbreviation')}</Small>
            </StyledTime>
          </Grid>
          <Grid item>
            <StyledTime disabled={disabled} highlighted={highlighted}>
              {seconds}
              <Small>{t('time.seconds_abbreviation')}</Small>
            </StyledTime>
          </Grid>
        </Grid>
      )}
    />
  );
};

CountDown.defaultProps = {
  before: new Date(),
  centered: true,
  disabled: false,
  highlighted: false,
};

export default CountDown;
